'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (FieldDisplayStates) {
  FieldDisplayStates["Hidden"] = "hidden";
  FieldDisplayStates["Disabled"] = "disabled";
  FieldDisplayStates["Visible"] = "visible";
})(exports.FieldDisplayStates || (exports.FieldDisplayStates = {}));

const RECAPTCHA_BYPASS_HEADER = 'x-recaptcha-bypass-key';
const FEATURES_TRAFFIC_KEY_HEADER = 'x-features-traffic-key';

const RECAPTCHA_BYPASS_COOKIE_NAME = 'Recaptcha-Bypass-Key';
const FEATURES_TRAFFIC_KEY_COOKIE_NAME = 'features-traffic-key';

exports.FEATURES_TRAFFIC_KEY_COOKIE_NAME = FEATURES_TRAFFIC_KEY_COOKIE_NAME;
exports.FEATURES_TRAFFIC_KEY_HEADER = FEATURES_TRAFFIC_KEY_HEADER;
exports.RECAPTCHA_BYPASS_COOKIE_NAME = RECAPTCHA_BYPASS_COOKIE_NAME;
exports.RECAPTCHA_BYPASS_HEADER = RECAPTCHA_BYPASS_HEADER;
//# sourceMappingURL=index.js.map
